<template>
  <div class="transactions container" id="million-bit-transactions">
    <h1 class="pt-3 honk-text">Pixels: <span v-text="pixelCount"></span></h1>

    <div class="btn-group btn-block">
        <button type="button" class="btn btn-icon btn-block btn-primary my-3" v-on:click="toggleView()" v-bind:class="{'disabled': toggledView === 'mint'}">
            Mint
        </button>
        <button type="button" class="btn btn-icon btn-block btn-primary my-3" v-on:click="toggleView()" v-bind:class="{'disabled': toggledView === 'repaint'}">
            Repaint
        </button>
    </div>

    <table style="width: 100%;">
      <tr v-for="transaction in transactionsFiltered" v-bind:key="transaction._id">
        <!-- <td>
          <b class="mr-1">{{ transaction.seq }}</b>
          <a v-bind:href="'https://basescan.org/tx/'+transaction.hash" target="_blank"><img src="/static/external-link.svg" class="external-link" alt="View transaction"/></a>
        </td> -->
        <td v-lazy-load>
          <img :data-url="s3Base+transaction.hash+'-crop.jpeg'" class="mr-4 my-4" />
        </td>
        
        <td class="text-left link">
          <a v-bind:href="transaction.url" target="_blank">{{ transaction.url }}</a>
        </td>

        <td>
          <a v-if="transaction.profile && transaction.profile.base_name" v-bind:href="'https://base.org/name/'+transaction.profile.base_name.replace('.base.eth', '')" target="_blank">
            <svg width="16" height="16" viewBox="0 0 111 111" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M54.921 110.034C85.359 110.034 110.034 85.402 110.034 55.017C110.034 24.6319 85.359 0 54.921 0C26.0432 0 2.35281 22.1714 0 50.3923H72.8467V59.6416H3.9565e-07C2.35281 87.8625 26.0432 110.034 54.921 110.034Z" fill="#0052FF"/>
            </svg>
          </a>
          <a v-if="transaction.profile && transaction.profile.website_url && transaction.profile.website_url !== transaction.url" v-bind:href="transaction.profile.website_url" target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-link-45deg" viewBox="0 0 16 16">
              <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z"/>
              <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z"/>
            </svg>
          </a>
          <a v-if="transaction.profile && transaction.profile.x_username" v-bind:href="'https://x.com/'+transaction.profile.x_username" target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-twitter-x" viewBox="0 0 16 16">
              <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"/>
            </svg>
          </a>
          <a v-if="transaction.profile && transaction.profile.tg_url" v-bind:href="transaction.profile.tg_url" target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telegram" viewBox="0 0 16 16">
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.287 5.906q-1.168.486-4.666 2.01-.567.225-.595.442c-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294q.39.01.868-.32 3.269-2.206 3.374-2.23c.05-.012.12-.026.166.016s.042.12.037.141c-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8 8 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629q.14.092.27.187c.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.4 1.4 0 0 0-.013-.315.34.34 0 0 0-.114-.217.53.53 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09"/>
            </svg>
          </a>
          <a v-if="transaction.profile && transaction.profile.token_ca" v-bind:href="'https://dexscreener.com/base/'+transaction.profile.token_ca" target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-graph-up" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M0 0h1v15h15v1H0zm14.817 3.113a.5.5 0 0 1 .07.704l-4.5 5.5a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61 4.15-5.073a.5.5 0 0 1 .704-.07"/>
            </svg>
          </a>
          <a v-if="transaction.profile && transaction.profile.nft_ca" v-bind:href="'https://magiceden.us/collections/base/'+transaction.profile.nft_ca" target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-images" viewBox="0 0 16 16">
              <path d="M4.502 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"/>
              <path d="M14.002 13a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2V5A2 2 0 0 1 2 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-1.998 2M14 2H4a1 1 0 0 0-1 1h9.002a2 2 0 0 1 2 2v7A1 1 0 0 0 15 11V3a1 1 0 0 0-1-1M2.002 4a1 1 0 0 0-1 1v8l2.646-2.354a.5.5 0 0 1 .63-.062l2.66 1.773 3.71-3.71a.5.5 0 0 1 .577-.094l1.777 1.947V5a1 1 0 0 0-1-1z"/>
            </svg>
          </a>
        </td>

        <td class="text-right">
          <div class="btn-group">
            <!-- <a v-bind:href="'https://opensea.io/assets/base/0x25b9afe64bb3593ec7e9dc7ef386a9b04c53f96e/'+transaction.tokenId" target="_blank" class="btn btn-outline-primary btn-sm">Open Sea</a> -->
            <!--  -->
            <router-link v-bind:to="'/plot/' + transaction.tokenId" class="btn btn-outline-primary btn-sm">Plot {{ transaction.tokenId }}</router-link>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
const BASE_S3_BUCKET_TRX = process.env.BASE_S3_BUCKET_TRX;
const BASE_S3_BUCKET = process.env.BASE_S3_BUCKET;
export default {
  name: 'transactions',
  data () {
    return {
      toggledView: 'mint',
      pixelCount: 0,
      transactions: [],
      transactionsFiltered: [],
      s3Base: BASE_S3_BUCKET_TRX,
      dataSrc: BASE_S3_BUCKET+'transactions.json?'+Date.now(),
    }
  },
  inject: ['updateAppRoute'],
  created: function () {
    this.updateAppRoute('list');
    axios.get(this.dataSrc)
      .then((response) => {
        this.transactions = response.data;
        this.filterTransactions();
      }).catch((error) => {
        console.error('Error fetching transactions:', error);
        // this.filterTransactions();
      });
  },
  methods: {
    toggleView: function() {
      if (this.toggledView === 'mint') {
        this.toggledView = 'repaint';
      } else {
        this.toggledView = 'mint';
      }
      this.filterTransactions();
    },
    filterTransactions: function() {
      this.transactionsFiltered = this.transactions.filter(transaction => {
        return this.toggledView === 'repaint' ? transaction.isRepaint : !transaction.isRepaint;
      });
      const sum = this.transactionsFiltered.reduce((accumulator, currentObject) => {
        return accumulator + currentObject.pixels;
      }, 0);
      this.pixelCount = sum;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  img.external-link {
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }
  #million-bit-transactions {
    background: #fff !important;
  }
  #million-bit-transactions table tr td.link {
    overflow-wrap: anywhere;
  }
</style>
<style>
@media screen and (max-device-width: 768px) {
  #million-bit-transactions .btn, #million-bit-transactions .form-control {
    font-size: 1.5rem;
  }
  #million-bit-transactions.container {
    max-width: 98%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Transactions.vue?1c970e51